<app-header [cartCount]="productService.getLocalCartProductLength()"></app-header>

<!-- Main Container -->
<div class="max-w-7xl mx-auto p-4 bg-gradient-to-br from-gray-50 to-white min-h-screen font-sans">
    
    <!-- Delivery Details Header - Compact -->
    <div class="mb-6">
        <div class="flex items-center gap-3 mb-2">
            <div class="w-10 h-10 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center shadow-md">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" />
                </svg>
            </div>
            <div>
                <h1 class="text-2xl font-bold text-gray-900">Delivery Details</h1>
                <p class="text-gray-600 text-sm">Where should we send your order?</p>
            </div>
        </div>
        <div class="h-1 w-24 bg-gradient-to-r from-orange-500 to-orange-400 rounded-full"></div>
    </div>

    <!-- Main Content Grid - Compact Layout -->
    <div class="grid lg:grid-cols-3 gap-6">
        
        <!-- Left Column - Saved Addresses (Compact) -->
        <div class="lg:col-span-1">
            <div class="bg-white rounded-2xl shadow-lg border border-gray-200 p-5 h-fit">
                <!-- Section Header -->
                <div class="flex items-center justify-between mb-5 pb-3 border-b border-gray-100">
                    <h3 class="text-lg font-bold text-gray-900 flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-orange-600" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
                        </svg>
                        Saved Addresses
                    </h3>
                    <span class="text-xs font-semibold bg-orange-100 text-orange-600 px-2 py-1 rounded-full">
                        {{deliveryListWithAddOption?.length - 1 || 0}} saved
                    </span>
                </div>

                <!-- Address Cards Container - Compact -->
                <div class="space-y-3 max-h-[400px] overflow-y-auto pr-2 custom-scrollbar">
                    <!-- Address Cards -->
                    <div *ngFor="let deliveryDetail of deliveryListWithAddOption; let i = index"
                         (click)="onDeliveryDetailsClick(deliveryDetail, i)"
                         class="group cursor-pointer transition-all duration-200">
                        
                        <!-- New Address Card (Last Item) -->
                        <ng-container *ngIf="deliveryDetail?.isNew; else addressCard">
                            <div class="bg-gradient-to-br from-gray-50 to-white rounded-xl p-4 border-2 border-dashed border-gray-300 hover:border-orange-400 hover:bg-orange-50/30 transition-all">
                                <div class="flex items-center justify-center gap-3">
                                    <div class="w-10 h-10 rounded-lg border-2 border-dashed border-gray-300 group-hover:border-orange-400 flex items-center justify-center transition-all">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400 group-hover:text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                        </svg>
                                    </div>
                                    <div class="text-left">
                                        <h4 class="font-semibold text-gray-700 group-hover:text-orange-600">Add New Address</h4>
                                        <p class="text-xs text-gray-500">Create new delivery location</p>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <!-- Regular Address Card -->
                        <ng-template #addressCard>
                            <div class="relative bg-white rounded-xl p-4 border-2 transition-all hover:shadow-md"
                                 [ngClass]="i == toogle 
                                     ? 'border-orange-500 bg-orange-50/50 shadow-sm' 
                                     : 'border-gray-200 hover:border-orange-300'">
                                
                                <!-- Selected Indicator -->
                                <div *ngIf="i == toogle" 
                                     class="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center shadow-sm">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 text-white" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                    </svg>
                                </div>

                                <!-- Address Content - Compact -->
                                <div class="space-y-2">
                                    <!-- Name and Phone -->
                                    <div class="flex items-start justify-between">
                                        <div class="flex items-center gap-2">
                                            <div class="w-8 h-8 rounded-lg bg-orange-100 flex items-center justify-center flex-shrink-0">
                                                <span class="text-xs font-bold text-orange-600">{{ deliveryDetail?.contactName?.charAt(0) }}</span>
                                            </div>
                                            <div class="min-w-0">
                                                <h4 class="text-sm font-semibold text-gray-900 truncate">{{ deliveryDetail?.contactName }}</h4>
                                                <p class="text-xs text-orange-600">{{ deliveryDetail?.contactNo }}</p>
                                            </div>
                                        </div>
                                        <button class="text-gray-400 hover:text-red-500 p-1 rounded hover:bg-red-50">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                            </svg>
                                        </button>
                                    </div>

                                    <!-- Address Details - Compact -->
                                    <div class="text-xs text-gray-600 space-y-1 pl-10">
                                        <p class="truncate">{{ deliveryDetail?.shippingPlotNo }}, {{ deliveryDetail?.shippingAddress }}</p>
                                        <p>{{ deliveryDetail?.shippingCity?.cityName }}, {{ deliveryDetail?.shippingPinCode }}</p>
                                    </div>

                                    <!-- Select Button - Compact -->
                                    <button class="w-full mt-2 py-2 text-xs font-medium rounded-lg transition-all"
                                            [ngClass]="i == toogle 
                                                ? 'bg-orange-500 text-white' 
                                                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'">
                                        {{ i == toogle ? 'Selected' : 'Select Address' }}
                                    </button>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>

        <!-- Right Column - Form (Compact) -->
        <div class="lg:col-span-2">
            <div class="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
                <!-- Form Header - Compact -->
                <div class="bg-gradient-to-r from-orange-500 to-orange-600 p-4">
                    <div class="flex items-center gap-3">
                        <div class="w-8 h-8 bg-white/20 backdrop-blur-sm rounded-lg flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-white" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" />
                            </svg>
                        </div>
                        <div>
                            <h3 class="text-lg font-bold text-white">New Delivery Address</h3>
                            <p class="text-orange-100 text-xs">Fill in your delivery details</p>
                        </div>
                    </div>
                </div>

                <!-- Form Content - Compact -->
                <form [formGroup]="createSetUpForm" (ngSubmit)="onCreateSetUpClick()" class="p-5 space-y-6">
                    
                    <!-- Contact Information - Compact -->
                    <div class="space-y-4">
                        <h4 class="text-md font-semibold text-gray-900 flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-orange-600" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd" />
                            </svg>
                            Contact Information
                        </h4>
                        
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div class="space-y-1">
                                <label class="text-sm text-gray-700 font-medium">Full Name</label>
                                <input type="text" formControlName="customerName" placeholder="Enter full name"
                                       class="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none transition-all" />
                            </div>
                            
                            <div class="space-y-1">
                                <label class="text-sm text-gray-700 font-medium">Mobile Number</label>
                                <input type="tel" formControlName="contactNo" placeholder="Enter mobile number"
                                       class="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none transition-all" />
                            </div>
                        </div>
                    </div>

                    <!-- Address Details - Compact -->
                    <div class="space-y-4">
                        <h4 class="text-md font-semibold text-gray-900 flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-orange-600" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" />
                            </svg>
                            Address Details
                        </h4>
                        
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div class="space-y-1">
                                <label class="text-sm text-gray-700 font-medium">Area / Locality</label>
                                <input type="text" formControlName="address" placeholder="Enter area or locality"
                                       class="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none transition-all" />
                            </div>
                            
                            <div class="space-y-1">
                                <label class="text-sm text-gray-700 font-medium">Building / Plot</label>
                                <input type="text" formControlName="plotNo" placeholder="Enter building or plot"
                                       class="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none transition-all" />
                            </div>
                            
                            <div class="space-y-1">
                                <label class="text-sm text-gray-700 font-medium">Street Name</label>
                                <input type="text" formControlName="street" placeholder="Enter street name"
                                       class="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none transition-all" />
                            </div>
                            
                            <div class="space-y-1">
                                <label class="text-sm text-gray-700 font-medium">Landmark (Optional)</label>
                                <input type="text" formControlName="landMark" placeholder="Enter nearby landmark"
                                       class="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none transition-all" />
                            </div>
                        </div>
                    </div>

                    <!-- Location Details - Compact -->
                    <div class="space-y-4">
                        <h4 class="text-md font-semibold text-gray-900 flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-orange-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                            Location Details
                        </h4>
                        
                        <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                            <!-- State -->
                            <div class="space-y-1">
                                <label class="text-sm text-gray-700 font-medium">State</label>
                                <div class="relative">
                                    <select formControlName="stateCode" (change)="onStateSelect($any($event.target).value)"
                                            class="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none appearance-none text-gray-700">
                                        <option value="" disabled selected>Select state</option>
                                        <option *ngFor="let state of stateList" [value]="state.refNo">{{ state.stateName }}</option>
                                    </select>
                                    <div class="absolute right-3 top-3 text-gray-400">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- District -->
                            <div class="space-y-1">
                                <label class="text-sm text-gray-700 font-medium">District</label>
                                <div class="relative">
                                    <select formControlName="districtCode" (change)="onDistrictSelect($any($event.target).value)"
                                            class="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none appearance-none text-gray-700">
                                        <option value="" disabled selected>Select district</option>
                                        <option *ngFor="let district of districtList" [value]="district.id">{{ district.name }}</option>
                                    </select>
                                    <div class="absolute right-3 top-3 text-gray-400">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- City -->
                            <div class="space-y-1">
                                <label class="text-sm text-gray-700 font-medium">City</label>
                                <div class="relative">
                                    <select formControlName="cityCode"
                                            class="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none appearance-none text-gray-700">
                                        <option value="" disabled selected>Select city</option>
                                        <option *ngFor="let city of cityList" [value]="city.id">{{ city.name }}</option>
                                    </select>
                                    <div class="absolute right-3 top-3 text-gray-400">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Pincode -->
                            <div class="space-y-1">
                                <label class="text-sm text-gray-700 font-medium">Pincode</label>
                                <input type="text" formControlName="pincode" (keyup)="choosePincode()" placeholder="Enter pincode"
                                       class="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none cursor-pointer" />
                            </div>
                        </div>
                    </div>

                    <!-- Map Section - Compact -->
                    <div class="space-y-4">
                        <h4 class="text-md font-semibold text-gray-900 flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-orange-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                            </svg>
                            Map Location
                        </h4>
                        
                        <!-- Coordinates - Compact -->
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                            <div class="space-y-1">
                                <label class="text-sm text-gray-700 font-medium">Latitude</label>
                                <input type="text" formControlName="latitude" placeholder="Latitude"
                                       class="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none" />
                            </div>
                            
                            <div class="space-y-1">
                                <label class="text-sm text-gray-700 font-medium">Longitude</label>
                                <input type="text" formControlName="longitude" placeholder="Longitude"
                                       class="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none" />
                            </div>
                        </div>
                        
                        <!-- Map Search and Map - Compact -->
                        <div class="space-y-3">
                            <div class="relative">
                                <input type="text" placeholder="Search location on map..." #search
                                       class="w-full pl-4 pr-12 py-3 bg-white border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none"
                                       [disabled]="!createSetUpForm.enabled" />
                                <button type="button" (click)="fetchCurrentLoc()"
                                        class="absolute right-2 top-2 p-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" />
                                    </svg>
                                </button>
                            </div>
                            
                            <!-- Map Container - Compact -->
                            <div class="rounded-lg overflow-hidden border border-gray-200">
                                <div class="bg-gray-50 px-3 py-2 border-b border-gray-200">
                                    <div class="flex items-center gap-2">
                                        <div class="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                                        <span class="text-xs text-gray-600">Drag marker to adjust location</span>
                                    </div>
                                </div>
                                <google-map height="250px" width="100%" [center]="center" [zoom]="zoom" [options]="mapOptions">
                                    <map-marker [position]="markerPosition" [options]="markerOptions" (mapDragend)="onMarkerDrag($event)">
                                    </map-marker>
                                </google-map>
                            </div>
                        </div>
                    </div>

                    <!-- Submit Button - Compact -->
                    <div class="pt-4 border-t border-gray-100">
                        <div class="flex flex-col sm:flex-row items-center justify-between gap-4">
                            <div class="text-xs text-gray-500 flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-green-500" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                                </svg>
                                <span>Your information is secure</span>
                            </div>
                            <button type="submit"
                                    class="px-8 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-lg shadow-md hover:shadow-lg hover:from-orange-600 hover:to-orange-700 transition-all active:scale-95 flex items-center gap-2">
                                <span>Save Delivery Address</span>
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<style>
.custom-scrollbar::-webkit-scrollbar {
    width: 4px;
}

.custom-scrollbar::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
    background: #f97316;
    border-radius: 4px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #ea580c;
}

/* Compact form styling */
input, select {
    font-size: 0.875rem;
    transition: all 0.2s ease;
}

/* Focus styles */
input:focus, select:focus {
    box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.1);
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .grid-cols-4 {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 640px) {
    .grid-cols-4 {
        grid-template-columns: 1fr;
    }
    
    .md\:grid-cols-2 {
        grid-template-columns: 1fr;
    }
}
</style>